<template>
    <table class="table table-condensed table-no-border">
        <tbody>
            <tr>
                <td>
                    <strong>{{ labels[1056] }}:<!-- Products --></strong>
                </td>
                <td class="text-right">
                    {{ toCurrency(pricing.total) }}
                </td>
            </tr>
            <tr>
                <td>
                    <strong>{{ labels[1057] }}:<!-- Tax --></strong>
                </td>
                <td class="text-right">
                    <template v-if="pricing.tax">
                        {{ toCurrency(pricing.tax) }}
                    </template>
                    <template v-else>
                        -
                    </template>
                </td>
            </tr>
            <tr>
                <td style="border-bottom:solid 1px ##ccc;">
                    <strong>{{ labels[1058] }}:<!-- Shipping --></strong>
                </td>
                <td class="text-right" style="border-bottom:solid 1px ##ccc;">

                    <template v-if="pricing.ship">
                        {{ toCurrency(pricing.ship) }}
                    </template>
                     <template v-else>
                        $0.00
                    </template>
                    <!-- </template> -->
                    <!-- <template v-else>
                        {{ labels[1677] }}<!- label: n/a ->
                    </template> -->
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td>
                    <strong>{{ labels[1009] }}:<!-- Total --></strong>
                </td>
                <td class="text-right">
                    <strong>
                        {{ toCurrency(total) }}<!--#lsCurrencyFormat(c.pricing.total + c.pricing.tax + c.pricing.ship, "local" , priceLocale())# -->
                    </strong>
                </td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import useCheckout from "../composables/useCheckout"
import useUtils from "../../shared/composables/useUtils"
import useCMS from "../../shared/composables/useCMS"
import useShipping from "../composables/useShipping"

export default {
    name: 'CheckoutTotalBox',
    components: {
    },
    setup () {
        const { labels } = useCMS();
        const { toCurrency } = useUtils();
        const { pricing, total, calculateTax } = useCheckout();
        const { shipMethod } = useShipping();
        calculateTax();

        return {
            labels,
            shipMethod,
            toCurrency,
            pricing,
            total
        }
    }
}
</script>
